import {Injectable, OnDestroy} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {AppConfig} from '../../app.config';
import {Observable} from 'rxjs/internal/Observable';
import { ICountByDay, IStats } from './count.by.day';
import { BadgeService } from 'src/app/services/badge/badge.service';
import { BehaviorSubject, Subject, firstValueFrom, first, map, Subscription, combineLatest } from 'rxjs';
import { ProjectService } from 'src/app/services/project.service';

@Injectable()
export class StatService implements OnDestroy {

  private projectIdSubscription: Subscription = null;

  private statsSubject: BehaviorSubject<IStats> = new BehaviorSubject(null);
  public stats$ = this.statsSubject.asObservable();

  private rangeFilterSubject: BehaviorSubject<Array<number>> = new BehaviorSubject([null,null]);
  private rangeFilter$ = this.rangeFilterSubject.asObservable();

  constructor(
    private authService: AuthenticationService,
    private projectService: ProjectService
  ) {

    this.projectIdSubscription = combineLatest([
      this.projectService.getSelectedProjectId(),
      this.rangeFilter$
    ]).subscribe(
      ([projectId,range]) => {

        if ( projectId == null ) {
          return;
        }

        this.getStats( projectId, range[0], range[1] ).subscribe({
          next: (data: IStats ) => {
            this.statsSubject.next( data );
          }
        });
      }     
    );

  }

  public fetch( start: number, end: number ) {
    // console.log( 'request fetch', start, end );
    this.rangeFilterSubject.next( [start, end] );
  }

  public getStats( projectId: string, start: number = null, end: number = null ) {
    let query = 'projectId=' + projectId + '&tz_shift=' + (-this.authService.tzOffset);
    if ( start != null ) {
      query += '&start=' + start
    }
    if ( end != null ) {
      query += '&end=' + end
    }
    return this.authService.get( AppConfig.BASE_URL + '/visitor2/stats/?' + query );
  }

  public getTotalHeatmapCountByDay(projectId: string, date: string): Observable<any> {
    const urlCounts =   AppConfig.HEATMAP_URL + AppConfig.HEATMAP_BADGE_VALUE_ENDPOINT + projectId + '/' + date;
    return this.authService.get(urlCounts);
  }

  ngOnDestroy() {
    if (this.statsSubject != null) {
      this.statsSubject.unsubscribe();
    }
    if ( this.projectIdSubscription != null ) {
      this.projectIdSubscription.unsubscribe();
    }
  }

}

